/**
 * Preload utilities for heavy components and dependencies.
 *
 * Historically this file warmed the on-device ML category models on
 * link hover and app boot. Stage 11 ripped out the ML tier in favor
 * of a keyword + cloud-LLM flow, leaving these functions with
 * nothing to actually preload. Form components have been statically
 * bundled for a while, so the route-level preloads were already
 * no-ops in that respect.
 *
 * Kept as exported no-ops because `PreloadLink` and `App.tsx` call
 * them from many places — turning the function signatures into
 * no-ops avoids a wide refactor of UI callsites. If a future
 * preload need arises (lazy-loaded chart libs, etc.), populate the
 * body of the relevant function instead of adding new exports.
 */

export async function preloadMLModelsForOffline(): Promise<void> {
  // No models to preload anymore.
}

export async function preloadCreateGroupDependencies(): Promise<unknown> {
  return undefined;
}

export async function preloadCreateExpenseDependencies(): Promise<unknown> {
  return undefined;
}

export function clearPreloadCache(): void {
  // No cache to clear anymore.
}
